module.exports = __webpack_public_path__ + "assets/smart-asset-youtube.9f15cf74.svg";